// Slaganje stavke radnog naloga.
//
// Zasto postoji: stavka ima 133 polja, a do sada ih je punio samo ekran
// "DocumentDetailCreateEdit3" - raspoređeno po nekoliko metoda (findItem,
// calculatePrice, calculatePriceWrk) i pomijesano s prikazom. Unos u retku
// treba sloziti isti takav zapis, pa se pravilo izdvaja ovdje, na jedno
// mjesto, i pokriva testom. Ekran i redak tako ne mogu racunati razlicito.
//
// Vazno: zapis se NE salje na posluzitelj. Stavke zive u
// "store.documentActivItems" dok se cijeli nalog ne spremi - isto kao sto radi
// i postojeci ekran (njegov "register" samo dopuni store i preracuna zaglavlje).
//
// Skupine ("FreeF6") i strane dokumenta - procitane iz samog ekrana naloga
// (metode "newMaterial" u DocumentDetailList3/31/32/33), ne pretpostavljene:
//   3  materijal   strana 2  -> kolicina u "itemPcsMinus"
//   31 rad         strana 3  -> sati u "itemPcsNeutral"
//   32 ostalo      strana 2  -> kolicina u "itemPcsMinus"
//   33 proizvedeno strana 1  -> kolicina u "itemPcsPlus"

export const MATERIJAL = 3
export const RAD = 31
export const OSTALO = 32
export const PROIZVEDENO = 33

// Strana dokumenta po skupini - odlucuje u koje polje ide kolicina.
const STRANA = {}
STRANA[MATERIJAL] = 2
STRANA[RAD] = 3
STRANA[OSTALO] = 2
STRANA[PROIZVEDENO] = 1

export const broj = (v) => {
  const n = parseFloat(v)
  return isNaN(n) ? 0 : n
}

export const zaokruzi = (v, d) => {
  const m = Math.pow(10, d === undefined ? 2 : d)
  return Math.round(broj(v) * m) / m
}

/** Polja koja stavka preuzima iz sifrarnika, ista kao u "findItem". */
const IZ_SIFRARNIKA = [
  'itemID', 'itemName', 'ItemNameShort', 'ItemCode', 'ItemEANCode',
  'itemDescription', 'itemUnit', 'ItemSize', 'ItemWeight', 'ItemWeightMeasure',
  'ItemDimMeasure', 'ItemDimLenght', 'ItemDimHeight', 'ItemDimDepth',
  'ItemWarehouse', 'ItemWarehouseRow', 'ItemWarehouseShelf', 'ItemWahrehouseFloor',
  'ItemPicture1', 'ItemPicture2', 'ItemPicture3', 'ItemPicture4',
  'ItemPicture5', 'ItemPicture6', 'ItemPicture7',
  'ItemBelongsToId', 'itemService', 'itemWeb', 'itemNotActiv', 'itemHideForever',
  'ItemSuppCode', 'itemMaxDiscount'
]

/** Polja koja stavka preuzima iz zaglavlja dokumenta. */
const IZ_ZAGLAVLJA = {
  CompanyId: 'CompanyId',
  CompanyNameDatabase: 'CompanyNameDatabase',
  BusinessYear: 'BusinessYear',
  UserId: 'UserId',
  email: 'email',
  documentName: 'documentName',
  documentIdGeneral: 'documentIdGeneral',
  documentDate: 'documentDate',
  partnerId: 'partnerId',
  partnerNameDatabase: 'partnerNameDatabase'
}

/**
 * Slozi stavku radnog naloga.
 *
 * @param {Object} o
 * @param {number} o.skupina   MATERIJAL, RAD, OSTALO ili PROIZVEDENO
 * @param {Object} o.glava     zaglavlje dokumenta (documentActivHead)
 * @param {Object} o.artikl    redak iz sifrarnika (nije obavezan za rad)
 * @param {number} o.kolicina
 * @param {number} o.cijena    nabavna za materijal/ostalo, prodajna za proizvod
 * @param {Object} o.rad       {sati, satnica, dnevnice, kilometri, radnik}
 * @param {number} o.databaseDocID
 * @param {string} o.korisnik  e-mail, ide u "LastUpdateBy"
 * @returns {Object} stavka spremna za "documentActivItems"
 */
export const slozi = (o) => {
  const op = o || {}
  const skupina = STRANA[op.skupina] ? op.skupina : MATERIJAL
  const glava = op.glava || {}
  const artikl = op.artikl || {}
  const rad = op.rad || {}
  const strana = STRANA[skupina]

  const z = {}

  // --- veza na dokument ---
  Object.keys(IZ_ZAGLAVLJA).forEach(k => { z[k] = glava[IZ_ZAGLAVLJA[k]] })
  z.documentId = parseInt(glava.documentId, 10) || 0
  z.databaseDocID = op.databaseDocID !== undefined ? op.databaseDocID : glava.id
  z.HomeCurrency = glava.documentHomeCurrency
  z.ForeignCurrency = glava.documentForeignCurrency
  z.ExRate = broj(glava.documentExRate)
  z.ItemHomeCurrency = glava.documentHomeCurrency
  z.ItemForeignCurrency = glava.documentForeignCurrency
  z.ItemExRate = broj(glava.documentExRate)
  z.FreeF6 = skupina
  z.documentSide = strana
  z.LastUpdateBy = op.korisnik || ''

  // --- iz sifrarnika ---
  IZ_SIFRARNIKA.forEach(k => { z[k] = artikl[k] })
  z.itemGroup = artikl.GroupId
  z.itemGroupName = artikl.GroupName
  z.ItemDefaultPicture = artikl.ItemDefaultPicture ? artikl.ItemDefaultPicture : null

  // --- kolicina ide u polje svoje strane; ostala dva ostaju nula ---
  const kolicina = zaokruzi(op.kolicina, 3)
  z.itemPcsPlus = strana === 1 ? kolicina : 0
  z.itemPcsMinus = strana === 2 ? kolicina : 0
  z.itemPcsNeutral = strana === 3 ? kolicina : 0

  // --- PDV: na nalogu se ne obracunava ni na trosku ni na proizvodu ---
  z.itemVAT1Percentage = zaokruzi(artikl.itemVAT1Percentage, 2)
  z.itemVAT2Percentge = 0
  z.itemVAT2Amount = 0
  z.itemDirectDuty1 = zaokruzi(artikl.itemDirectDuty1, 2)
  z.itemDirectDuty2 = 0

  // Na nalogu nema rabata ni marze ni u jednoj skupini.
  z.itemDiscountPercentage1 = 0
  z.itemDiscountAmount1 = 0
  z.itemMargin = 0
  z.itemMarginAmount = 0
  z.itemMaxDiscount = 0

  if (skupina === RAD) {
    // Rad: sati x satnica, plus dnevnice i kilometri. Kolicina su sati.
    const sati = broj(rad.sati)
    const satnica = broj(rad.satnica)
    z.hashtag = rad.radnik || ''
    z.EmployeeId = rad.radnikId !== undefined ? rad.radnikId : null
    z.empWorkDay = rad.datum || glava.documentDate
    z.empWrkHrs = sati
    z.empWrkExpHrs = satnica
    z.empExp1 = broj(rad.dnevnice)
    z.empExp2 = broj(rad.kilometri)
    z.itemPcsNeutral = zaokruzi(sati, 3)

    const iznos = zaokruzi(sati * satnica + broj(rad.dnevnice) + broj(rad.kilometri), 2)
    z.itemPrice = satnica
    z.itemBaseAmount = iznos
    z.itemBaseAmountNoVAT = iznos
    z.itemVAT1Percentage = 0
    z.itemVAT1Amount = 0
    z.itemAmountWithVAT = iznos
    z.itemPriceWithVAT = satnica
    // Rad ulazi u kostanje preko nabavne strane, isto kao materijal.
    z.itemSuppBasePrice = iznos
    z.itemSuppPrice = iznos
    z.itemSuppDiscount = 0
    z.itemSuppBasePriceAmount = iznos
    z.itemSuppDiscountAmount = 0
    z.itemSuppPriceAmount = iznos
    z.itemDiscountPrice = satnica
  } else {
    const cijena = zaokruzi(op.cijena, 3)
    const osnovica = zaokruzi(cijena * kolicina, 2)

    if (skupina === PROIZVEDENO) {
      // Proizvod nosi PRODAJNU cijenu; nabavna strana ostaje prazna jer se
      // kostanje racuna iz troska cijelog naloga, a ne upisuje po stavci.
      z.itemSuppBasePrice = 0
      z.itemSuppPrice = 0
      z.itemSuppDiscount = 0
      z.itemSuppBasePriceAmount = 0
      z.itemSuppDiscountAmount = 0
      z.itemSuppPriceAmount = 0
    } else {
      // Materijal i ostalo: cijena je NABAVNA, bez rabata i marze.
      z.itemSuppBasePrice = cijena
      z.itemSuppPrice = cijena
      z.itemSuppDiscount = 0
      z.itemSuppBasePriceAmount = osnovica
      z.itemSuppDiscountAmount = 0
      z.itemSuppPriceAmount = osnovica
    }

    z.itemPrice = cijena
    z.itemDiscountPrice = cijena
    z.itemBaseAmount = osnovica
    z.itemBaseAmountNoVAT = osnovica
    z.itemVAT1Amount = zaokruzi(osnovica * (z.itemVAT1Percentage / 100), 2)
    z.itemAmountWithVAT = zaokruzi(osnovica + z.itemVAT1Amount, 2)
    z.itemPriceWithVAT = kolicina !== 0 ? zaokruzi(z.itemAmountWithVAT / kolicina, 2) : cijena
  }

  z.itemDirectDuty1Amount = zaokruzi(z.itemDirectDuty1 * kolicina, 2)
  z.itemFullTotal = zaokruzi(z.itemAmountWithVAT + z.itemDirectDuty1Amount, 2)

  return z
}

/**
 * Zbroj zaglavlja radnog naloga iz stavaka.
 *
 * Ista podjela koju radi "makeSum" u DocumentDetailCreateEdit3: trosak po
 * skupinama ide u "FreeF1" (materijal), "FreeF2" (rad), "FreeF3" (ostalo),
 * proizvedeno u "FreeF4", a radni sati u "FreeF5". Financijska kartica
 * (DocumentViewCard4) cita tocno ta polja.
 */
export const zbrojNaloga = (stavke) => {
  const sve = Array.isArray(stavke) ? stavke : []
  const z = {FreeF1: 0, FreeF2: 0, FreeF3: 0, FreeF4: 0, FreeF5: 0}
  sve.forEach(s => {
    if (!s || !s.itemBaseAmount) { return }
    const skupina = parseInt(s.FreeF6, 10)
    const iznos = broj(s.itemBaseAmount)
    if (skupina === MATERIJAL) { z.FreeF1 += iznos }
    if (skupina === RAD) { z.FreeF2 += iznos; z.FreeF5 += broj(s.empWrkHrs) }
    if (skupina === OSTALO) { z.FreeF3 += iznos }
    if (skupina === PROIZVEDENO) { z.FreeF4 += iznos }
  })
  Object.keys(z).forEach(k => { z[k] = zaokruzi(z[k], 2) })
  return z
}

/** Je li stavka dovoljno popunjena da se smije dodati. */
export const provjeri = (o) => {
  const op = o || {}
  const greske = []
  if (op.skupina === RAD) {
    if (broj(op.rad && op.rad.sati) <= 0) { greske.push('Upiši radne sate.') }
    if (broj(op.rad && op.rad.satnica) <= 0) { greske.push('Upiši satnicu.') }
  } else {
    if (!op.artikl || !op.artikl.itemID) { greske.push('Odaberi artikl.') }
    if (broj(op.kolicina) === 0) { greske.push('Upiši količinu.') }
  }
  return greske
}

export default {slozi, provjeri, zbrojNaloga, MATERIJAL, RAD, OSTALO, PROIZVEDENO, broj, zaokruzi}
